export default __webpack_public_path__ + "static/media/Q9_1_resized.35a8b134.jpg";